module.exports = __webpack_public_path__ + "img/arrow-sliders.122a7182.svg";